module.exports = __webpack_public_path__ + "img/img-7.49511387.png";